export enum UserRole {
    WEAK = 'weak-auth',
    STRONG = 'strong-auth',
}
